module.exports = __webpack_public_path__ + "img/bg_pic4.ee3c3202.png";